import { render, staticRenderFns } from "./TranProgramActivityView.vue?vue&type=template&id=c0e6bac2"
import script from "./TranProgramActivityView.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports